import { theme } from '@dot/design-system';
import { default as styled } from 'styled-components';

import { pulse } from '@/styles/helpers';

type Props = {
  isLoading: boolean;
  shortUrl?: string;
};

const ShortUrl = styled.strong`
  margin-left: 0.125rem;
`;

const ShortUrlLink = styled.a`
  margin-left: 0.125rem;
  color: ${theme.colors.oxfordBlue[80]};
  font-size: 0.875rem;
  font-weight: 700;
  overflow-wrap: anywhere;
  text-decoration: underline;
`;

const ShortUrlSkeleton = styled(ShortUrl)`
  display: inline-block;
  width: 10.25rem;
  height: 1.25rem;
  vertical-align: sub;
  background-color: ${theme.colors.slateGray[30]};
  border-radius: 0.25rem;
  animation: ${pulse} 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
`;

export const ShortenedUrl = ({ isLoading, shortUrl }: Props) => {
  if (isLoading || !shortUrl) {
    return <ShortUrlSkeleton />;
  }

  return (
    <ShortUrlLink href={shortUrl} id="short-url" rel="noopener noreferrer" target="_blank" title={shortUrl}>
      {shortUrl}
    </ShortUrlLink>
  );
};
